import React from "react";
import ReactDOMServer from "react-dom/server";
import { MemoryRouter } from "react-router-dom";
import { ContentFormatter, Theme } from "@ebscois/react-component-library";
import { PresetStoreProvider } from "../store";

const noop = () => null;

const renderSectionToString = (section, isSubsection = false) => {
  if (!section) {
    return "";
  }

  const titleTagName = isSubsection ? "h3" : "h2";
  const sectionTitle = section.title
    ? `<${titleTagName}>${section.title}</${titleTagName}>`
    : "";

  const sectionData = section.data || "";
  const subsections = section.subSections
    ? section.subSections
        .map((subsection) => renderSectionToString(subsection, true))
        .join("")
    : "";

  return sectionTitle + sectionData + subsections;
};

const wrapSectionHtml = (sectionHtml, wrapperClassName) =>
  `<div class="${wrapperClassName}">${sectionHtml}</div>`;

export const preprocessTopic = (content, state, preProcessorInstance) => {
  const sectionWrapperClassName = "section-wrapper";

  const topicHtml = content
    .map((section) =>
      wrapSectionHtml(renderSectionToString(section), sectionWrapperClassName)
    )
    .join("");

  const processedHtml = ReactDOMServer.renderToStaticMarkup(
    <Theme ui="dmp">
      <MemoryRouter>
        <PresetStoreProvider state={state} dispatch={noop}>
          <ContentFormatter preProcessors={preProcessorInstance}>
            {topicHtml}
          </ContentFormatter>
        </PresetStoreProvider>
      </MemoryRouter>
    </Theme>
  );

  const parser = new DOMParser();

  // We don't want to have DOMParser parse it as `text/html` so that it doesn't
  // attempt to fix invalid DOM nesting (e.g. <div> inside <table> etc)
  const mimeType = "text/xml";
  const virtualDocument = parser.parseFromString(processedHtml, mimeType);
  return virtualDocument.querySelectorAll(`.${sectionWrapperClassName}`);
};
